module.exports = __webpack_public_path__ + "02_medium_beige.261d0abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_medium_beige.png
// module id = ilov
// module chunks = 0